<template>
    <main>
        <div class="container">
            <div class="navsteps navstepts-flight">
                <div :class="{'navsteps__item': true, 'active': dataStep === 'calc'}">
                    <div class="number">1</div>
                    <div class="descr">Розрахунок</div>
                </div>
                <div :class="{'navsteps__item': true, 'active': dataStep === 'choice'}">
                    <div class="number">2</div>
                    <div class="descr">Вибір СК</div>
                </div>
                <div :class="{'navsteps__item': true, 'active': dataStep === 'order'}">
                    <div class="number">3</div>
                    <div class="descr">Оформлення</div>
                </div>
            </div>
            <slot></slot>
        </div>
    </main>
</template>
<script>
export default {
    props: ['dataStep'],
}
</script>
<style src="../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
